export const en = {
  'error-screen-title': 'Error'
}
